import { Stack, Step, StepLabel, Stepper, styled } from '@mui/material';
import React, { FC } from 'react';
import { StepIconProps } from '@mui/material/StepIcon';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Typography from 'src/components/Typography';
import { colors, sizes } from 'src/themes/default';
import { StackProps } from '@mui/system';
import { progressStepsCreate } from './constants';

const StyledStack = styled(Stack)<StackProps>(({ theme }) => ({
    width: '100%',
    margin: '20px auto',
    maxWidth: '500px',
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    zIndex: 1,
    width: '54px',
    height: '54px',
    borderRadius: '27px',
    // border: '1px solid silver',
    lineHeight: '54px',
    verticalAlign: 'middle',
    textAlign: 'center',
    backgroundColor: colors['background_B-1'],
    ...(ownerState.active && {
        backgroundColor: colors.primary_O,
        fontWeight: sizes.bold_W,
        color: colors.primary_W,
    }),
    ...(ownerState.completed && {
        color: colors.text_T1,
        fontWeight: sizes.bold_W,
        border: `1px solid ${colors.background_B3}`,
    }),
}));

const ColorlibStepIcon = (props: StepIconProps) => {
    const { active, completed, className } = props;

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {Number(props.icon)}
        </ColorlibStepIconRoot>
    );
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 28,

        '&  .MuiStepConnector-lineHorizontal': {
            borderColor: colors.text_T3,
        },
    },
}));

export interface ProgressNewPropsType {
    activeTab: string;
}

const ProgressNew: FC<ProgressNewPropsType> = (props) => {
    const activeStepIndex = progressStepsCreate.findIndex((item) => item.key === props.activeTab);
    return (
        <StyledStack spacing={4}>
            <Stepper alternativeLabel activeStep={activeStepIndex} connector={<ColorlibConnector />}>
                {progressStepsCreate.map((step, index) => {
                    let textSx: any = { color: colors.text_T2 };

                    if (index === activeStepIndex) {
                        textSx = { color: colors.primary_O, fontWeight: sizes.bold_W };
                    } else if (index < activeStepIndex) {
                        textSx = { fontWeight: sizes.bold_W };
                    }
                    return (
                        <Step key={step.label}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>
                                <Typography variant="body1" sx={textSx}>
                                    {step.label}
                                </Typography>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </StyledStack>
    );
};

export default ProgressNew;
